import { isElement, isString } from "lodash";
import React from "react";
import {checkNav, MENU_IS_VISIBLE_UP} from "./index";
import {
  MORE_ARROW_BTN_CLASS,
  NAV_BAR_RIGHT_SIDE_ELEMENTS_CLASS
} from "./constans";

const extractOnlyElementNodes = node =>
  [...node.childNodes].filter(element => isElement(element));

const canRemove = navBarWidth =>
  window.innerWidth > MENU_IS_VISIBLE_UP && navBarWidth > window.innerWidth;

const canAdd = (navBarWidth, navBarItems) => {
  if (
    window.innerWidth > MENU_IS_VISIBLE_UP &&
    navBarWidth < window.innerWidth &&
    getAllHiddenElements(navBarItems).length > 0
  ) {
    let candidateToShow = getFirstShowedElement(navBarItems);
    if (getWidthDomElement(candidateToShow) + navBarWidth < window.innerWidth) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const getFirstHiddenElement = items => {
  let result;

  for (let i = items.length - 1; i > 0; i--) {
    if (
      !items[i].classList.contains("d-none") &&
      !items[i].classList.contains(MORE_ARROW_BTN_CLASS)
    ) {
      result = items[i + 1] ? items[i + 1] : false;
      if(result) {
        result = result.classList.contains(MORE_ARROW_BTN_CLASS) ? false : result;
      }
      break;
    } else {
      result = null;
    }
  }
  return result;
};

const getFirstShowedElement = items => {
  let result;

  for (let i = items.length - 1; i > 0; i--) {
    if (
      !items[i].classList.contains("d-none") &&
      !items[i].classList.contains(MORE_ARROW_BTN_CLASS)
    ) {
      result = items[i];
      break;
    } else {
      result = null;
    }
  }

  return result;
};

const getAllHiddenElements = items => {
  let result = [];

  for (let i = items.length - 1; i > 0; i--) {
    if (
      items[i].classList.contains("d-none") &&
      !items[i].classList.contains("three-dots")
    ) {
      result.push(items[i]);
    }
  }

  return result;
};

const getWidthDomElement = node => {
  let style = node.currentStyle || window.getComputedStyle(node);

  let width = node.offsetWidth;
  let margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
  let padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
  let border =
    parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

  return width + margin + padding + border;
};

const sumWidthDomElements = (node, selectors) => {
  return selectors.reduce((prvValue, currValue) => {
    let element;
    if (isString(prvValue)) {
      element = node.querySelector(prvValue);
      prvValue = getWidthDomElement(element);
    }
    if (isString(currValue)) {
      element = node.querySelector(currValue);
      currValue = getWidthDomElement(element);
    }
    return prvValue + currValue;
  });
};

const toggleRightSideElements = () => {
  let rightSideContainer = document.querySelector(
    `.${NAV_BAR_RIGHT_SIDE_ELEMENTS_CLASS}`
  );
  let moreBtn = document.querySelector(`.${MORE_ARROW_BTN_CLASS}`)

  if(rightSideContainer.style.display === "none") {
    rightSideContainer.style.display = ""
    moreBtn.classList.remove("open")
  } else {
    rightSideContainer.style.setProperty("display", "none", "important")
    moreBtn.classList.add("open")

  }


  moreBtn.classList.add()
  checkNav(false);
};

const hideLastItem = items => {
  let element = getFirstShowedElement(items);
  if (element !== false) {
    element.classList.add("d-none");
    return true;
  } else {
    return false;
  }
};

const showLastItem = items => {
  let element = getFirstHiddenElement(items);
  if (element !== false) {
    element.classList.remove("d-none");
    return true;
  } else {
    return false;
  }
};

const addMoreArrowBtn = container => {
  let element = document.createElement("li");
  element.setAttribute("class", `${MORE_ARROW_BTN_CLASS} nav-item ml-2 mr-2`);

  element.addEventListener("click", toggleRightSideElements);

  let mountedElement = container.appendChild(element);
  mountedElement.innerHTML = "<button><i class='fas fa-chevron-right'></i></button>";
};

const hideMoreArrowBtn = container => {
  let element = container.querySelector(`.${MORE_ARROW_BTN_CLASS}`);
  element.classList.add("d-none");
};

const showMoreArrowBtn = container => {
  let element = container.querySelector(`.${MORE_ARROW_BTN_CLASS}`);
  element.classList.remove("d-none");
};

const moreArrowBtnIsExist = container =>
  !!container.querySelector(`.${MORE_ARROW_BTN_CLASS}`);

const moreArrowBtnIsVisible = container =>
  !container
    .querySelector(`.${MORE_ARROW_BTN_CLASS}`)
    .classList.contains(`d-none`);

export {
  addMoreArrowBtn,
  hideMoreArrowBtn,
  showMoreArrowBtn,
  moreArrowBtnIsExist,
  moreArrowBtnIsVisible,
  canRemove,
  canAdd,
  showLastItem,
  hideLastItem,
  sumWidthDomElements,
  getFirstHiddenElement,
  getFirstShowedElement,
  getWidthDomElement,
  extractOnlyElementNodes,
  getAllHiddenElements
};
